import React, { useContext, useState, useEffect } from "react";
import { Text, TouchableOpacity } from "react-native";

import headerStyles from "./headerStyles";
import { navigate } from "../../../../helpers/utils";
import AppContext from "../../../../appContext";
import TutorialsHelper from "../../tutorials/TutorialsHelper";
import JournalContext from "../../journal/JournalContext";

export default function ExitTutorialsButton({ journalContext, style }) {
  const { controller } = useContext(AppContext);
  const { onExitTutorial } = journalContext || {}; //TODO: !!!!, context was dropped
  const [showTutorials, setShowTutorials] = useState(false);

  useEffect(() => {
    setShowTutorials(
      TutorialsHelper.isTutorialMode(controller?.state?.showTutorials),
    );
  }, [controller?.state?.showTutorials]);

  const exitTutorials = () => {
    if (onExitTutorial) {
      onExitTutorial();
    } else {
      setShowTutorials(false);
      controller.toggleTutorialsMode();
      navigate(controller, "home_card");
    }
  };

  return (
    <>
      {showTutorials ? (
        <TouchableOpacity
          onPress={exitTutorials}
          style={[headerStyles.exitButton, style]}
        >
          <Text style={headerStyles.exitButtonText}>Exit Tutorial</Text>
        </TouchableOpacity>
      ) : null}
    </>
  );
}
